import "./App.css";
import Relationship from "./components/relationship.tsx";
import FlamesGame from "./flamesgame.js";
import Home from "./home.js";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/flamesgame" element={<FlamesGame />} />
        <Route path="/relationship" element={<Relationship />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
